export const EVENT_SHOW_MINI_CART = "show-mini-cart";
export const EVENT_HIDE_MINI_CART_LOADER = "hide-mini-cart-loader";
export const EVENT_ADD_TO_CART = "eggo-add-to-cart";
export const EVENT_GENERATE_UPSELLS = "eggo-upsells";
export const EVENT_UPDATE_PRICES = "eggo-update-prices";
export const EVENT_CALCULATE_SHIPPING = "eggo-calculate-shipping";
export const EVENT_SHOW_QUANTITY_UPSELL = "eggo-show-quantity-upsell";
export const EVENT_REMOVE_GIFTS = "eggo-remove-gifts";
export const EVENT_TOGGLE_CHECKOUT = "eggo-toggle-checkout";

export const documentEventDispatcher = (eventName, data) => {
    const showMiniCartEvent = new CustomEvent(eventName, {'detail': data});
    document.dispatchEvent(showMiniCartEvent);
}